// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-3643eebc]{position:relative}.bottom-shadow[data-v-3643eebc]{-webkit-box-shadow:inset -10px -15px 10px 0 #fff;box-shadow:inset -10px -15px 10px 0 #fff;position:absolute;width:100%;height:85%}", ""]);
// Exports
module.exports = exports;
